export default "__VITE_PUBLIC_ASSET__55f63901__"